import { use } from 'react';

// auth provider
import AuthContext from 'contexts/JWTContext';
// import AuthContext from 'contexts/FirebaseContext';
// import AuthContext from 'contexts/Auth0Context';
// import AuthContext from 'contexts/AWSCognitoContext';
// import AuthContext from 'contexts/SupabaseContext';

// ==============================|| AUTH HOOKS ||============================== //

// src/hooks/useAuth.js
// src/hooks/useAuth.js
// (Remove the unused AuthContext import)
export default function useAuth() {
  const USER_KEY  = import.meta.env.VITE_TOKEN_STORAGE_KEY || 'auth_token';
  const ADMIN_KEY = import.meta.env.VITE_ADMIN_TOKEN_STORAGE_KEY || 'admin_auth_token';

  // Compute admin prefix with basename
  const BASENAME = (import.meta.env.VITE_APP_BASE_NAME || '/').replace(/\/+$/, '');
  const ADMIN_PREFIX = `${BASENAME === '/' ? '' : BASENAME}/admin`;

  const path = window.location.pathname.replace(/\/+$/, '');
  const isAdmin =
    path === ADMIN_PREFIX || path.startsWith(`${ADMIN_PREFIX}/`);

  const KEY = isAdmin ? ADMIN_KEY : USER_KEY;
  const token =
    localStorage.getItem(KEY) || sessionStorage.getItem(KEY) || '';

  // === Debug logs ===
  // eslint-disable-next-line no-console
  console.log('[useAuth] path=', path, 'BASENAME=', BASENAME, 'isAdmin=', isAdmin);
  // eslint-disable-next-line no-console
  console.log('[useAuth] KEY=', KEY, 'token?', !!token);

  const to = (p) =>
    `${BASENAME === '/' ? '' : BASENAME}${p.startsWith('/') ? p : `/${p}`}`;

  return {
    isLoggedIn: !!token,
    logout: () => {
     localStorage.clear();
        sessionStorage.clear();
      // eslint-disable-next-line no-console
      console.log('[useAuth.logout] removed KEY=', KEY, 'redirecting to', isAdmin ? to('/admin/login') : to('/login'));
      window.location.assign(isAdmin ? to('/admin/login') : to('/login'));
    }
  };
}
